import React, {useState, useCallback} from 'react'
import { InputProfile } from '../../input/InputProfile';
import { allTimezones } from '../../../timezone';


export function ActionNodeTimer({form, errors, loading, setForm}) {

    const [timerTypes] = useState([
        { key: "S", text: "секунда", value: "S" },
        { key: "M", text: "минута", value: "M" },
        { key: "H", text: "час", value: "H" },
        { key: "D", text: "день", value: "D" },
        { key: "T", text: "дата", value: "T" },
    ]);

    const handleChangeForm = useCallback((e) => {
        const name = e.target.name;
        const value = e.target.value;
        setForm({...form, [name]: value});
    }, [form, setForm]);

    return <div className="profile__wrap">
        {form.timer_type !== "T" && <InputProfile type="number"
                        title="Значение"
                        name="timer_value"
                        placeholder="Введите значение"
                        value={form.timer_value}
                        error={errors.timer_value || false}
                        disabled={loading}
                        onChange={handleChangeForm}/>}

        <div className="profile__group">
            <label className="profile__label help">&nbsp;</label>
            <select
                className={`dropdown__select select ${errors.type ? 'is-invalid' : ''}`}
                name="timer_type"
                value={form.timer_type}
                onChange={handleChangeForm}
            >
                {timerTypes.map(option => (
                    <option key={option.value} value={option.value}>
                        {option.text}
                    </option>
                ))}
            </select>
        </div>

        {form.timer_type === "T" && <div className="profile__wrap">
            <div className="profile__group">
                <label className="profile__help help">Дата действия</label>
                <input
                    type="datetime-local"
                    className="profile__input input"
                    value={form.action_date || ''}
                    onChange={handleChangeForm}
                    name="action_date"
                />
            </div>
            <div className="profile__group">
                <label className="profile__label help">Часовой пояс</label>
                <select
                    className={`dropdown__select select ${errors.timezone_cfg ? 'is-invalid' : ''}`}
                    name="timezone_cfg"
                    value={form.timezone_cfg}
                    onChange={handleChangeForm}
                >
                    <option value="">пожалуйста выберите</option>
                    {Object.keys(allTimezones).map(k => (
                        <option key={k} value={k}>
                            {allTimezones[k]}
                        </option>
                    ))}
                </select>
            </div>
        </div>}
    </div>;

}